import {
  Button,
  ControlGroup,
  InputGroup,
  NumericInput,
  Tag,
} from "@blueprintjs/core";
import React from "react";
import { apiCallPost, compareTwoObjects } from "../fns/util";
import { inject, observer } from "mobx-react";
import _ from "lodash";
import MultiSelectWrapper from "../utils/MultiSelectWrapper";
import AsyncSelWrap from "../utils/AsyncSelWrap";
import cogoToast from "cogo-toast";
import { nanoid } from "nanoid";

class SxPriceMaster extends React.Component {
  state = {
    changed: false,
    sxStepIds: [],
    items: [],
    sites: [],
    panels: [],
    isCashless: false,
    ratePaise: 0,

    contractRateCapPaise: 0,
    targetDeltaPaise: 0,
    effectiveBillableRatePaise: 0,
    discount: 0,
    finalBillableRatePaise: 0,
    procedureChargeBeforeDisctPaise: 0,
    procedureChargeAfterDisctPaise: 0,
    specialLessPaise: 0,
    implantCostNetPaise: 0,
    implantCostShownPaise: 0,

    /** SEARCHES */
    searchingItems: false,
    itemSearchResults: [],
    searchItem: null,
    searchingSxSteps: false,
    sxStepsSearchResults: [],
    searchSxStep: null,
    searchingPanels: false,
    panelSearchResults: [],
    searchPanel: null,

    isEditingPanelCashRate: false,
    inputValue: "",

    cashRate: [],
    payorRate: [],

    cashRatePaise: 0,
    cashRateBranch: [],
  };
  componentDidMount() {
    this.setState({ ...this.props.data });
  }
  search = async (
    string,
    searchResArray,
    isSearchingShowSpinner,
    selectedItem,
    apiUrl,
    searchApiURL
  ) => {
    if (!string) {
      this.setState({
        [searchResArray]: [],
        [selectedItem]: null,
      });
      return;
    }
    try {
      this.setState({ [isSearchingShowSpinner]: true });
      let payload = { prefix: string || "" };
      if (apiUrl === "item") {
        payload["showWhich"] = "CURRENT";
      }
      let res = await apiCallPost(searchApiURL, payload);
      let results = res;
      results = _.filter(results, (x) => !x.isShell);
      this.setState({
        [searchResArray]: results,
        [isSearchingShowSpinner]: false,
      });
    } catch (err) {
      cogoToast.error(
        "There was an error in searching. Please check the console for more details.",
        { position: "bottom-left" }
      );
      console.log(err);
    }
  };
  renderSearchAndAdded = (
    placeholder,
    apiUrl,
    searchResults,
    isSearching,
    whichItem,
    resultsArray,
    searchApiURL
  ) => {
    return (
      <>
        <AsyncSelWrap
          showSelectProp={true}
          placeholder={placeholder}
          searching={this.state[isSearching]}
          items={this.state[searchResults].map((each) => {
            if (apiUrl === "item") {
              return {
                ...each,
                item: each.entityName,
                helper: each.itemNameSuffix,
                entityTypeString: each.isItemService ? "Service" : "Product",
              };
            }
            if (apiUrl === "sxSteps") {
              return {
                ...each,
                item: each.sxStepName,
                entityTypeString: each.specialisation,
              };
            }
            if (apiUrl === "panels") {
              return {
                ...each,
                item: each.entityName,
              };
            }
            return null;
          })}
          selectedItem={
            this.state[whichItem]
              ? {
                  ...this.state[whichItem],
                  item:
                    apiUrl === "item"
                      ? this.state[whichItem].itemNameSuffix
                        ? `${this.state[whichItem].entityName} - ${this.state[whichItem].itemNameSuffix}`
                        : this.state[whichItem].entityName
                      : null,
                }
              : null
          }
          update={(thing) =>
            this.search(
              thing,
              searchResults,
              isSearching,
              whichItem,
              apiUrl,
              searchApiURL
            )
          }
          onChange={(thing) => {
            let ll = this.state[resultsArray];
            let idx = _.findIndex(ll, (x) => x.elementId === thing._id);
            if (idx > -1) {
              cogoToast.error("This item is already added.");
              return;
            }
            this.setState(
              {
                [whichItem]: thing,
                [resultsArray]: [
                  ...this.state[resultsArray],
                  {
                    nanoid: nanoid(),
                    elementName:
                      apiUrl === "item"
                        ? thing.itemNameSuffix
                          ? `${thing.entityName} - ${thing.itemNameSuffix}`
                          : thing.entityName
                        : apiUrl === "sxSteps"
                        ? thing.sxStepName
                        : apiUrl === "panels"
                        ? thing.entityName
                        : null,
                    elementId: thing._id,
                  },
                ],
              },
              () =>
                this.props.onUpdate(
                  compareTwoObjects(this.state, this.props.data)
                )
            );
          }}
        />
        <br />
        {this.state[resultsArray].map((each) => {
          return (
            <ControlGroup style={{ marginTop: "5px" }}>
              <Tag
                minimal
                multiline
                large
                intent="primary"
                onRemove={() => {
                  let ll = this.state[resultsArray];
                  let idx = _.findIndex(ll, (x) => x.nanoid === each.nanoid);
                  ll.splice(idx, 1);
                  this.setState({ [resultsArray]: ll }, () =>
                    this.props.onUpdate(
                      compareTwoObjects(this.state, this.props.data)
                    )
                  );
                }}
              >
                {each.elementName}
              </Tag>
            </ControlGroup>
          );
        })}
      </>
    );
  };

  handleRemove = (index) => {
    const updatedPanelRepetition = [...this.state.panelRepetition];
    updatedPanelRepetition.splice(index, 1);
    this.setState({ panelRepetition: updatedPanelRepetition });
  };

  render() {
    if (this.props.entity === "sxPriceMasterTable") {
      return (
        <>
          <td>
            <ControlGroup vertical>
              <Tag minimal large intent="primary" multiline>
                {this.state.entityName}
              </Tag>
            </ControlGroup>
          </td>
          <td>
            <MultiSelectWrapper
              intent="primary"
              key={nanoid()}
              items={this.props.sites}
              selectedItems={this.state.sites}
              onChange={(items) =>
                this.setState({ sites: items, changed: true }, () =>
                  this.props.onUpdate(
                    compareTwoObjects(this.state, this.props.data)
                  )
                )
              }
            />
          </td>
          <td>
            <ControlGroup>
              <NumericInput
                style={{ width: "6em" }}
                value={
                  this.state.contractRateCapPaise
                    ? this.state.contractRateCapPaise / 100
                    : 0
                }
                buttonPosition="NONE"
                rightElement={<Tag minimal>₹</Tag>}
                onValueChange={(number) =>
                  this.setState(
                    {
                      contractRateCapPaise: number * 100,
                      changed: true,
                    },
                    () =>
                      this.props.onUpdate(
                        compareTwoObjects(this.state, this.props.data)
                      )
                  )
                }
              />
            </ControlGroup>
          </td>
          <td>
            <ControlGroup>
              <NumericInput
                style={{ width: "6em" }}
                value={
                  this.state.targetDeltaPaise
                    ? this.state.targetDeltaPaise / 100
                    : 0
                }
                buttonPosition="NONE"
                rightElement={<Tag minimal>₹</Tag>}
                onValueChange={(number) =>
                  this.setState(
                    {
                      targetDeltaPaise: number * 100,
                      changed: true,
                    },
                    () =>
                      this.props.onUpdate(
                        compareTwoObjects(this.state, this.props.data)
                      )
                  )
                }
              />
            </ControlGroup>
          </td>

          <td>
            <ControlGroup vertical>
              <Tag minimal large intent="primary" multiline>
                {this.state.effectiveBillableRatePaise / 100}
              </Tag>
            </ControlGroup>
          </td>

          <td>
            <ControlGroup>
              <NumericInput
                style={{ width: "4em" }}
                value={this.state.discount ? this.state.discount : 0}
                buttonPosition="NONE"
                rightElement={<Tag minimal>%</Tag>}
                onValueChange={(number) =>
                  this.setState(
                    {
                      discount: number,
                      changed: true,
                    },
                    () =>
                      this.props.onUpdate(
                        compareTwoObjects(this.state, this.props.data)
                      )
                  )
                }
              />
            </ControlGroup>
          </td>
          <td>
            <ControlGroup vertical>
              <Tag minimal large intent="primary" multiline>
                {this.state.gst}%
              </Tag>
            </ControlGroup>
          </td>

          <td>
            <ControlGroup vertical>
              <Tag minimal large intent="primary" multiline>
                {this.state.finalBillableRatePaise / 100}
              </Tag>
            </ControlGroup>
          </td>

          <td>
            <ControlGroup>
              <NumericInput
                style={{ width: "6em" }}
                value={
                  this.state.procedureChargeBeforeDisctPaise
                    ? this.state.procedureChargeBeforeDisctPaise / 100
                    : 0
                }
                buttonPosition="NONE"
                rightElement={<Tag minimal>₹</Tag>}
                onValueChange={(number) =>
                  this.setState(
                    {
                      procedureChargeBeforeDisctPaise: number * 100,
                      changed: true,
                    },
                    () =>
                      this.props.onUpdate(
                        compareTwoObjects(this.state, this.props.data)
                      )
                  )
                }
              />
            </ControlGroup>
          </td>

          <td>
            <ControlGroup vertical>
              <Tag minimal large intent="primary" multiline>
                {this.state.procedureChargeAfterDisctPaise / 100}
              </Tag>
            </ControlGroup>
          </td>
          <td>
            <ControlGroup vertical>
              <Tag minimal large intent="primary" multiline>
                {this.state.specialLessPaise / 100}
              </Tag>
            </ControlGroup>
          </td>

          <td>
            <ControlGroup vertical>
              <Tag minimal large intent="primary" multiline>
                {this.state.implantCostNetPaise / 100}
              </Tag>
            </ControlGroup>
          </td>

          <td>
            <ControlGroup vertical>
              <Tag minimal large intent="primary" multiline>
                {this.state.implantCostShownPaise / 100}
              </Tag>
            </ControlGroup>
          </td>
        </>
      );
    } else {
      return (
        <>
          <td>
            <ControlGroup vertical>
              <Tag minimal large intent="primary" multiline>
                Cash
              </Tag>
            </ControlGroup>
          </td>

          <td>
            <MultiSelectWrapper
              intent="primary"
              key={nanoid()}
              items={this.props.sites}
              selectedItems={this.state.sites}
              onChange={(items) => {
                this.setState({
                  cashRateBranch: items,

                  changed: true,
                });
              }}
            />
          </td>

          <td>
            {this.state.isEditingPanelCashRate ? (
              <ControlGroup>
                <NumericInput
                  style={{ width: "9em" }}
                  value={
                    this.state.cashRatePaise
                      ? this.state.cashRatePaise / 100
                      : 0
                  }
                  buttonPosition="NONE"
                  rightElement={<Tag minimal>₹</Tag>}
                  onValueChange={(number) => {
                    this.setState({
                      cashRatePaise: number * 100,

                      changed: true,
                    });
                  }}
                />
              </ControlGroup>
            ) : (
              <ControlGroup vertical>
                <Tag minimal large intent="primary" multiline>
                  {this.state.cashRatePaise / 100}
                </Tag>
                <Button
                  minimal
                  icon="edit"
                  onClick={() =>
                    this.setState({ isEditingPanelCashRate: true })
                  }
                />
              </ControlGroup>
            )}
          </td>
        </>
      );
    }
  }
}

export default inject("authStore")(observer(SxPriceMaster));
